import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useCartStore } from '../../store/cartStore'
import { useUIStore } from '../../store/uiStore'

const Header = ({ isZoomed, onToggleZoom }) => {
  const cartItemsCount = useCartStore((state) => state.getTotalItems())
  const customBack = useUIStore((state) => state.customBack)
  const location = useLocation()
  const navigate = useNavigate()
  const isHomePage = location.pathname === '/'

  const handleBack = () => {
    if (customBack) {
      customBack()
    } else {
      navigate(-1)
    }
  }

  return (
    <header className="header">
      {/* Left - Zoom toggle or Back button */}
      <div className="header-left">
        {isHomePage ? (
        <button 
          className="header-menu-btn" 
          onClick={onToggleZoom}
          aria-label={isZoomed ? "Zoom out" : "Zoom in"}
        >
          {isZoomed ? (
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          ) : (
            '+'
          )}
        </button>
        ) : (
          <button 
            className="header-menu-btn" 
            onClick={handleBack}
            aria-label="Back"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M19 12H5M12 19l-7-7 7-7" />
            </svg>
          </button>
        )}
      </div>

      {/* Center - Logo */}
      <div className="header-center">
        <Link to="/" className="header-logo" aria-label="CRYSQUAD">
          <img src="/logo.gif" alt="CRYSQUAD" className="header-logo-img" loading="lazy" />
        </Link>
      </div>

      {/* Right - Cart */}
      <div className="header-right">
        <Link to="/cart" className="header-cart-link" aria-label="Cart">
          {cartItemsCount > 0 && (
            <span className="header-cart-count">{cartItemsCount}</span>
          )}
          <div className="header-cart-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
              <rect x="5" y="11" width="14" height="10" rx="1" />
              <path d="M8 11V8a4 4 0 1 1 8 0v3" />
            </svg>
          </div>
        </Link>
      </div>
    </header>
  )
}

export default Header
